import React, { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import decryptData from '../../helpers/Decryption';
import { Button, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import viewIcon from '../../assets/images/icons/viewModalIcon.svg';
import editIcon from '../../assets/images/icons/icon-edit.svg';
import delIcon from '../../assets/images/icons/icon-delete.svg';
import CommonModal from '../Modals/CommonModal';
import { useCSVDownloader } from 'react-papaparse';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const QRCodes = () => {
    //-------------------------------------------------
    const navigate = useNavigate();
    const { CSVDownloader, Type } = useCSVDownloader();
    const [stationQrCodes, setStationQrCodes] = useState([]);
    const [showDelModal, setShowDelModal] = useState(false);
    const [delId, setDelId] = useState();
    const [selectedRows, setSelectedRows] = useState([]);
    const [buttonDisable, setButtonDisable] = useState(true);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [loading, setLoading] = useState(false);

    const [showBulkDel, setShowBulkDel] = useState(false);

    const { getToken, user } = useAuth();

    const role = useMemo(() => user?.role, [user]);

    const [search, setSearch] = useState({
        search: '',
        status: 'active'
    });
    
    const fetchStationQRCodes = async (page = currentPage, size = pageSize) => {
        try {
            setLoading(true);
            const token = getToken();
            const stationData = await new WebApiCalls().getAllStations(token, size, page, search.status, search.search, undefined);
            if (stationData?.code === 200) {
                const decryptedData = await decryptData(stationData.data);
                setStationQrCodes(decryptedData?.stations);
                setTotalRecords(decryptedData?.totalRecords);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchStationQRCodes(1, pageSize); // Reset to page 1 when search changes
    }, [search]);

    // Handle pagination change
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchStationQRCodes(page, pageSize);
    };

    // Handle page size change
    const handlePerRowsChange = (newPerPage, page) => {
        setPageSize(newPerPage);
        setCurrentPage(1); // Reset to first page when changing page size
        fetchStationQRCodes(1, newPerPage);
    };

    //-------------------------------------------------
    const handleRowSelected = React.useCallback((state) => {
        const selectedIds = state.selectedRows.map((item) => {
            return item._id;
        });
        setSelectedRows(selectedIds);
    }, []);

    useEffect(() => {
        if (selectedRows && selectedRows?.length > 0) {
            setButtonDisable(false);
        }
        if (selectedRows && selectedRows?.length === 0) {
            setButtonDisable(true);
        }
    }, [selectedRows]);
    //-------------------------------------------------
    const columns = [
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Name</span>
                </h6>
            ),
            selector: (row) => row?.name,
            center: true,
            sortable: true
        },
        // qrCode
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">QR Code</span>
                </h6>
            ),
            selector: (row) => (
                <div className="d-flex">
                    <div className="d-flex">
                        <img src={row?.qrCode} alt="" width={50} height={50} />
                    </div>
                </div>
            ),
            center: true
            // sortable: true
        },

        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Status</span>
                </h6>
            ),
            selector: (row) => (
                <select
                    value={row?.status}
                    onChange={(e) => {
                        e.preventDefault();
                        // update status stationUpdate
                        const token = getToken();
                        new WebApiCalls()
                            .stationUpdate(token, row?._id, { status: e.target.value })
                            .then((res) => {
                                if (res?.code === 200) {
                                    setCurrentPage(1);
                                    fetchStationQRCodes(1, pageSize);
                                    toast.success('QRCode is  Updated successfully.');
                                }
                            })
                            .catch((err) => {
                                toast.success('Oops...! Something went wrong');
                            });
                    }}
                    className={row?.status === 'inactive' ? 'status-selector-inactive' : 'status-selector'}
                    aria-label="Default select example"
                >
                    <option value={'active'}>Active</option>
                    <option value={'inactive'}>Inactive</option>
                </select>
            ),
            center: true
            // sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Action</span>
                </h6>
            ),
            selector: (row) => (
                <div className="d-flex">
                    <div className="d-flex">
                        <OverlayTrigger delay={{ show: 300, hide: 0 }} placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>View details</Tooltip>}>
                            <div className="view-detail">
                                <img
                                    key={row?._id}
                                    width={15}
                                    className="me-3"
                                    src={viewIcon}
                                    alt=""
                                    onClick={() => {
                                        navigate('/qr-codes/view', {
                                            state: {
                                                data: row
                                            }
                                        });
                                    }}
                                />
                            </div>
                        </OverlayTrigger>

                        {role === 'admin' && (
                            <OverlayTrigger delay={{ show: 300, hide: 0 }} placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>Edit</Tooltip>}>
                                <div className="edit-detail">
                                    <img
                                        width={15}
                                        className="me-3"
                                        src={editIcon}
                                        alt=""
                                        onClick={() => {
                                            navigate('/qr-codes/edit', {
                                                state: {
                                                    data: row
                                                }
                                            });
                                        }}
                                    />
                                </div>
                            </OverlayTrigger>
                        )}
                        {/* only admin can perform the action */}
                        {role === 'admin' && (
                            <OverlayTrigger delay={{ show: 300, hide: 0 }} placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>Delete</Tooltip>}>
                                <div className="del-detail">
                                    <img
                                        width={15}
                                        src={delIcon}
                                        alt=""
                                        onClick={() => {
                                            setDelId(row._id);
                                            setShowDelModal(true);
                                        }}
                                    />
                                </div>
                            </OverlayTrigger>
                        )}
                    </div>
                </div>
            ),
            center: true
            // sortable: true
        }
    ];
    const customStyles = {
        rows: {
            style: {
                // minHeight: '72px' // override the row height
                textAling: 'center'
            }
        },
        headCells: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
                backgroundColor: '#13aa61',
                color: 'white',
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        }
    };
    //-------------------------------------------------
    return (
        <>
            <div style={{ padding: '20px' }}>
                <Row className="mb-4 mt-1">
                    <Col sm={3} md={3} style={{ paddingRight: 0 }} className="mb-4 mb-sm-0">
                        <input
                            type={'search'}
                            className="search-input-bar"
                            placeholder={'Search here...'}
                            onChange={(e) => {
                                setSearch((prev) => ({ ...prev, search: e.target.value }));
                            }}
                        />
                    </Col>
                    <Col sm={4} md={4} className="mb-4 mb-sm-0">
                        <div className="d-flex gap-10">
                            <div className="d-flex gap-10 justify-content-start">
                                <select
                                    onChange={(e) => {
                                        setSearch((prev) => ({ ...prev, status: e.target.value }));
                                    }}
                                    className="status-selector w-120"
                                    aria-label="Default select example"
                                >
                                    <option value={'active'}>Active</option>
                                    <option value={'inactive'}>Inactive</option>
                                </select>
                            </div>
                        </div>
                    </Col>
                    <Col sm={5} md={5} lg={5}>
                        <div className="d-flex gap-10 justify-content-end h-100">
                            {!buttonDisable && (
                                <>
                                    <Button
                                        className="add-record-btn  justify-content-center w-140"
                                        style={{ background: 'red' }}
                                        onClick={(e) => {
                                            setShowBulkDel(true);
                                        }}
                                        disabled={buttonDisable}
                                    >
                                        Delete
                                    </Button>
                                </>
                            )}

                            {stationQrCodes?.length !== 0 && (
                                <CSVDownloader
                                    type={Type.Button}
                                    filename={'all_qr_codes'}
                                    bom={true}
                                    data={[...stationQrCodes]?.map((row) => {
                                        const { _id, created_at, saved_locations, status, ...rest } = row;
                                        return rest;
                                    })}
                                    className="export-file justify-content-center w-140 align-items-center"
                                    style={{ background: '#198754', cursor: 'pointer', color: 'white', borderRadius: '10px', padding: '10px' }}
                                >
                                    Export CSV
                                </CSVDownloader>
                            )}
                        </div>
                        {/* </Col> */}
                    </Col>
                </Row>
                <DataTable
                    columns={columns}
                    data={stationQrCodes}
                    selectableRows
                    pagination
                    paginationServer
                    paginationTotalRows={totalRecords}
                    paginationDefaultPage={currentPage}
                    paginationPerPage={pageSize}
                    paginationRowsPerPageOptions={[10, 20, 50, 100]}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    progressPending={loading}
                    responsive
                    direction="auto"
                    fixedHeaderScrollHeight="300px"
                    subHeaderAlign="right"
                    subHeaderWrap
                    customStyles={customStyles}
                    onSelectedRowsChange={handleRowSelected}
                    clearSelectedRows={toggleCleared}
                />

                <CommonModal
                    handleClose={() => {
                        setShowDelModal(false);
                    }}
                    show={showDelModal}
                    handleDelete={() => {
                        try {
                            let token = getToken();
                            if (delId && token) {
                                // call delete api
                                new WebApiCalls()
                                    .stationDelete(token, delId)
                                    .then((res) => {
                                        if (res?.code === 200) {
                                            toast.success('QRCode is  deleted successfully.');
                                            setCurrentPage(1);
                                            fetchStationQRCodes(1, pageSize);
                                        }
                                    })
                                    .catch((err) => {
                                        toast.success('Oops...! Something went wrong');
                                    });
                            }
                        } catch (error) {}
                        setShowDelModal(false);
                    }}
                    text={'Are you sure, you want to delete this QR Code?'}
                />

                <CommonModal
                    handleClose={() => {
                        setShowBulkDel(false);
                    }}
                    show={showBulkDel}
                    handleDelete={() => {
                        try {
                            const token = getToken();
                            let obj = {
                                _ids: selectedRows
                            };
                            if (token) {
                                new WebApiCalls()
                                    .stationBulkDelete(token, obj)
                                    .then((res) => {
                                        if (res?.code === 200) {
                                            toast.success('QRCode is  deleted successfully.');
                                            setToggleCleared(false);
                                            setCurrentPage(1);
                                            fetchStationQRCodes(1, pageSize);
                                        }
                                    })
                                    .catch((err) => {
                                        toast.success('Oops...! Something went wrong');
                                    });
                            }
                        } catch (error) {}
                    }}
                    text={selectedRows?.length > 1 ? 'Are you sure, you want to delete selected QRCodes?' : 'Are you sure, you want to delete selected QRCode?'}
                />
            </div>
        </>
    );
};

export default QRCodes;
